// extracted by mini-css-extract-plugin
module.exports = {"oceanevcharger":"OceanEvCharger_oceanevcharger__YVcW3"};